export default __webpack_public_path__ + "static/media/snapper.4f5513a4.png";